import { Product } from '@/manager/product/models/product.model';

export interface State {
    list: Product[];
}

export const state: State = {
    list: [],
};
